import { useRouter } from "next/router";

import { useStoreContext } from "../contexts/StoreDataContext";
import useCollection from "../hooks/useCollection";
import ArrowSvg from "./Carousel/ArrowSvg";
import LinkItem from "./LinkItem";

const SideNavDrawer = ({ isOpen, toggleDrawer }) => {
  const context = useStoreContext();
  const store = context?.storeData;
  const router = useRouter();

  const {
    data: collectionsData,
    isLoading: isCollectionsLoading,
    error: collectionsError,
  } = useCollection(store?.id, "");

  const collections = collectionsData ? collectionsData.collections : [];

  if (collectionsError) return <div>Error loading collections</div>;

  const onClickItem = (path) => {
    router.push(path);
    toggleDrawer();
  };

  if (collectionsError) return <div>Error loading collections</div>;

  return (
    <aside
      className={`fixed left-0 top-0 z-[101] h-screen w-screen transform overflow-y-auto bg-background text-fontBackground shadow-lg transition-transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="flex items-center p-8">
        <span className="text-lg font-bold">{store?.storeName}</span>

        {/* close button */}
        <button
          className="absolute right-5 top-10 z-50 inline-block w-[22px] border-0 bg-transparent"
          onClick={toggleDrawer}
          aria-label="Close drawer"
        >
          <div
            className={`relative h-[15px] w-full rotate-0 transform cursor-pointer transition duration-500 ease-in-out ${isOpen ? "open" : ""}`}
          >
            <span
              className={`duration-250 absolute left-0 top-[7px] block h-[2px] w-full transform rounded-lg bg-primary opacity-100 transition ease-in-out ${isOpen ? "rotate-45" : "rotate-0"}`}
            ></span>
            <span
              className={`duration-250 absolute left-0 top-[7px] block h-[2px] w-full transform rounded-lg bg-primary opacity-100 transition ease-in-out ${isOpen ? "-rotate-45" : "rotate-0"}`}
            ></span>
          </div>
        </button>
      </div>

      <nav className="mt-3">
        <ul className="space-y-0 text-lg">
          <li onClick={() => toggleDrawer()}>
            <LinkItem href="/" label="Home" className="block px-4 py-2 hover:opacity-80" />
          </li>

          <li onClick={() => toggleDrawer()}>
            <LinkItem href="/shop" label="Shop" className="block px-4 py-2 hover:opacity-80" />
          </li>

          {isCollectionsLoading ? (
            <li></li>
          ) : (
            collections.length > 0 &&
            collections.map((collection) => (
              <li key={collection._id}>
                <a
                  className="flex cursor-pointer items-center justify-between px-4 py-2 hover:opacity-80"
                  onClick={() => onClickItem(`/shop?collection=${collection.name}`)}
                >
                  {collection.name}

                  <ArrowSvg className="h-5 w-5" color="var(--font-background)" />
                </a>
              </li>
            ))
          )}

          <li onClick={() => toggleDrawer()}>
            <LinkItem
              href="/contact"
              label="Contact us"
              className="mb-4 block px-4 py-2 hover:opacity-80"
            />
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default SideNavDrawer;
